import axios from "axios";
import { MainUrl } from "../constants";

const API_URL = `${MainUrl}/users`;

export const Me = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/me/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    if (error.status == 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("access_level");
      window.location.href = "/";
    }

    throw error;
  }
};

export const usersRestaurantCHK = async (token, restaurant_id) => {
  try {
    const response = await axios.get(
      `${API_URL}/restaurant_users_chk/${restaurant_id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    if (error.status == 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("access_level");
      window.location.href = "/";
    }
  }
};

export const UsersForUpdate = async (token, restaurantId, name, sync) => {
  try {
    const response = await axios.post(
      `${API_URL}/users_for_update/?restaurant_id=${restaurantId}&name=${name}&sync=${sync}`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.log(error.response);
    // if (error.status == 401){
    //   localStorage.removeItem('token');
    //   localStorage.removeItem('access_level');
    //   window.location.href = '/';
    // }
  }
};

export const UserByName = async (token, name) => {
  try {
    const response = await axios.post(
      `${API_URL}/users_by_name/?name=${name}`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.log(error.response);
    // if (error.status == 401){
    //   localStorage.removeItem('token');
    //   localStorage.removeItem('access_level');
    //   window.location.href = '/';
    // }
  }
};

export const getUser = async (token, userId) => {
  try {
    console.log(userId);
    const response = await axios.get(`${API_URL}/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    if (error.status == 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("access_level");
      window.location.href = "/";
    }
  }
};

export const GetUsers = async (token, page, limit) => {
  const response = await axios.post(
    `${API_URL}/?page=${page}&limit=${limit}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response.data;
};

export const UpdateUser = async (token, data) => {
  console.log(data);
  try {
    const response = await axios.patch(`${API_URL}/${data.id}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error.response);
    return error.response.data;
  }
};

export const CreateUser = async (
  token,
  {
    username,
    post_id,
    is_active,
    hashed_password,
    registration,
    name,
    surname,
    restaurant_id,
    area_id,
    last_update,
    syncing_with_bk,
    is_superuser,
  },
) => {
  const body = {
    username,
    post_id,
    is_active,
    hashed_password,
    registration,
    name,
    surname,
    restaurant_id,
    area_id,
    last_update,
    syncing_with_bk,
    is_superuser,
  };
  try {
    const response = await axios.post(`${MainUrl}/auth/register`, body, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error.response, 888);
    return error.response;
  }
};

export const GetTurvReport = async (
  token,
  startDate,
  endDate,
  restaurantId = 0,
) => {
  try {
    const bodyRequest = {
      start_date: startDate,
      end_date: endDate,
      restaurant_id: restaurantId || null,
    };
    const response = await axios.post(
      `${MainUrl}/reports/turv/`,
      bodyRequest,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
      },
    );
    return response;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("access_level");
      window.location.href = "/";
    }
    throw error;
  }
};

export const GetEmployee = GetTurvReport;

export const GetActiveUsers = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/active/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    // if (error.status == 401){
    //   localStorage.removeItem('token');
    //   localStorage.removeItem('access_level');
    //   window.location.href = '/';
    // }
  }
};
